export default {
  invalidEmailFormat: "Please enter a valid email address",
  nonUniqueEmail: "This email has already been used by another person",
  invalidPhoneFormat: "Phone number should have ONLY digits",
  invalidPasswordFormat: "Your password doesn't meet the requirements shown below",
  passwordsDontMatch: "Your passwords must match!",
  passwordTooShort: "Your password must be at least 8 characters"
};
